<template>
  <div>
    <el-dialog
      v-el-drag-dialog
      :visible.sync="innerVisible"
      :title="this.$t('CargoMsg.Cargo_Distribution')"
      width="380px"
      class="make-invoice-adjust-balance-dialog"
      :close-on-click-modal="false"
    >
      <div>
        <el-form label-width="100px" label-position="left">
          <el-form-item :label="this.$t('CargoMsg.Cargo_Acquirer')">
            <cargo-user-select
              no="recipientId"
              :method-params="{officeId:$store.getters.currentOfficeId}"
              :merge-load="true"
              @change="item=>recipientId=item.value"
            />
          </el-form-item>
        </el-form>
        <div slot="footer" style="text-align:right">
          <el-button type="primary" @click="saveHandler">{{ $t('CargoMsg.Cargo_Save') }}</el-button>
          <el-button @click="innerVisible=false">{{ $t('common.btn.cancel') }}</el-button>
        </div>

      </div>
    </el-dialog>
  </div>
</template>

<script>

import CargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import cargoUserSelect from '@/components/Cargo/Common/cargoUserSelect'
import { allocationFunc } from '@/api/booking/mblManagement'
import { getLoading4Cxt } from '@/utils/utilBaseElement'

export default {
  name: 'DistributionWindow',
  components: { CargoAdvanceSelect, cargoUserSelect },
  props: {
    visible: { type: Boolean, required: true },
    mblList: { type: Array, required: true }
  },
  data() {
    return {
      loading: false,
      gridApi: null,
      selectTypeNames: TYPE_NAMES,
      fullscreenLoading: null,
      recipientId: 0
    }
  },
  computed: {
    innerVisible: {
      get() {
        return this.visible
      },
      set(val) {
        if (!val) {
          this.$emit('close', val)
        } else {
          this.$emit('open', val)
        }
      }
    }
  },
  async beforeMount() {

  },
  mounted() {},
  methods: {
    saveHandler() {
      const data = {
        mblNoList: this.mblList,
        userId: this.recipientId
      }
      this.fullscreenLoading = getLoading4Cxt()
      allocationFunc(data).then((res) => {
        this.innerVisible = false
        this.$emit('queryList')
      }).finally(() => {
        this.fullscreenLoading.close()
      })
    }
  }
}
</script>
